import { Paths } from "../typings/ts-utils";
import { isObject, traverseObjectPath } from "./object";

export const insertArray = (
  values: string[] | string = [],
  arr: string[],
  afterIndex?: number,
): string[] => {
  const toInsert = typeof values === "string" ? [values] : values;
  if (!afterIndex) {
    return [...toInsert, ...arr];
  }
  const start = arr.slice(undefined, afterIndex);
  const end = arr.slice(afterIndex);
  return [...start, ...toInsert, ...end];
};

export function splitArray<T>(arr: T[], binSize: number): T[][] {
  const res: T[][] = [[]];
  const arrC: T[] = [...arr];
  let idx = 0;
  while (res[idx].length < binSize && arrC.length > 0) {
    res[idx].push(arrC.shift() as T);
    if (res[idx].length === binSize && arrC.length) {
      idx++;
      res.push([]);
    }
  }
  return res;
}

// TODO: Add Unit Tests
export function sortObj<T = unknown>(
  path: Paths<T, 4>,
  order: "asc" | "desc" = "asc",
) {
  return function sortHandler(a: T, b: T) {
    if (!path) {
      return 1;
    }
    const aVal = isObject(a) ? traverseObjectPath(path, a, true) : null;
    const bVal = isObject(b) ? traverseObjectPath(path, b, true) : null;
    if (typeof aVal === "number" && typeof bVal === "number") {
      return order === "asc" ? Math.sign(aVal - bVal) : Math.sign(bVal - aVal);
    }

    return order === "asc"
      ? String(aVal).localeCompare(String(bVal), undefined, {
          numeric: true,
        })
      : String(bVal).localeCompare(String(aVal), undefined, {
          numeric: true,
        });
  };
}

type Ent = [string | number, unknown];
export function entriesToValues(
  func: Exclude<Parameters<typeof Array.prototype.sort>["0"], undefined>,
) {
  return function innerTransfer([, val]: Ent, [, val2]: Ent) {
    return func(val, val2);
  };
}

export function uniqueStringReducer(res: string[], item: string) {
  if (!res.includes(item)) {
    res.push(item);
  }
  return res;
}

export function dedupe<T>(ar: T[]): T[] {
  return ar.reduce<T[]>(
    (_ar, s) => (!_ar.includes(s) ? _ar.concat(s) : _ar),
    [],
  );
}

export function asArray<T>(value: T | T[]): T[] {
  return Array.isArray(value) ? value : [value];
}

/**
 * Filter the object property (an array) if it exists
 *
 * returns on object with property [name] and value being the filtered array
 * - if the original property value is not an array then return the value unfiltered
 *
 * @todo this G generic doesn't return the type of array. Its just never always
 *
 * @param obj
 * @param name
 * @param filter
 * @returns
 */
export function filterIfDefined<
  T,
  K extends keyof T,
  // oxlint-disable-next-line typescript/no-explicit-any
  G = T[K] extends ArrayLike<any> ? T[K][0] : never,
>(
  obj: T,
  name: K,
  filter: (v: G) => boolean,
): Record<K, G[]> | Record<K, T[K]> | object {
  const t = obj ? obj[name] : undefined;
  return obj && t
    ? Array.isArray(t)
      ? { [name]: t.filter(filter) }
      : { [name]: t }
    : {};
}
